import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { CourseType } from "../../types/entitiesModel";
import { useNavigate } from "react-router-dom";
import BorderColorIcon from "@mui/icons-material/BorderColor";

interface AppTableProps {
  data: CourseType[];
}

const AppTableCourses: React.FC<AppTableProps> = ({ data }) => {
  const navigate = useNavigate();

  const handleEditCourse = (id: number) => {
    navigate(`/admin/courses/editCourse/${id.toString()}`);
  };

  // Función para convertir las horas a formato 12 horas con AM/PM
  const formatTo12Hour = (time: string) => {
    if (!time) return "--"; // Manejo de valores vacíos o nulos
    const [hours, minutes, seconds] = time.split(":");
    const date = new Date();
    date.setHours(Number(hours), Number(minutes), Number(seconds));
    return new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3">Cursos</Typography>
          <Box
            sx={{
              overflowX: "auto",
              width: "100%",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                mt: 3,
                whiteSpace: "nowrap",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Id
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Categoría
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Nombre
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Comienza (AM/PM)
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Termina (AM/PM)
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Día
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Mensualidad
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Inscripción
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography color="textSecondary" variant="h6">
                      Editar
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((course) => (
                  <TableRow key={course.id}>
                    <TableCell>
                      <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>
                        {course.id}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>
                        {course.category.name || "--"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6" sx={{ fontWeight: "600" }}>
                        {course.group_name || "--"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6" sx={{ fontWeight: "600" }}>
                        {formatTo12Hour(course.start_time)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6" sx={{ fontWeight: "600" }}>
                        {formatTo12Hour(course.end_time)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6" sx={{ fontWeight: "600" }}>
                        {course.day_of_week || "--"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {course.monthly_fee}
                        </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {course.enrollment_fee}
                        </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Fab
                        color="success"
                        aria-label="edit"
                        sx={{
                          width: 35,
                          height: 35,
                          cursor: "pointer",
                          backgroundColor: "green",
                          "&:hover": {
                            backgroundColor: "darkgreen",
                          },
                        }}
                        onClick={() => handleEditCourse(course.id)}
                      >
                        <BorderColorIcon
                          sx={{
                            width: 20,
                            height: 20,
                            color: "white",
                          }}
                        />
                      </Fab>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AppTableCourses;
